const find = async (predicate, callback) => {
    let props = [];
    await Word.run(async (context) => {
        const properties = context.document.properties.customProperties;
        properties.load("key,type,value");

        await context.sync();

        const results = properties.items.filter(predicate);
        if (results) {
            props = [...props, ...results];
            if (callback) {
                await callback(context, props);
            }
        }
    });

    return props;
}

const getKeys = async predicate => {
    let keys = [];

    await Word.run(async (context) => {
        const properties = context.document.properties.customProperties;
        properties.load("key,type,value");

        await context.sync();

        const allKeys = properties.items.map(p => p.key);

        if (predicate) {
            keys = [...keys, ...allKeys.filter(predicate)];
        } else {
            keys = [...keys, ...allKeys]
        }
    });

    return keys
}

const getProp = async key => {
    const results = await find(p => p.key === key);
    if (results && results.length > 0) {
        return results[0];
    }

    return null;
}

const get = async key => {
    const prop = await getProp(key);
    if (prop) {
        return prop.value;
    }

    return null;
}

const set = async (key, value) => {
    await Word.run(async context => {
        context.document.properties.customProperties.add(key, value);

        await context.sync();
    });
}

const remove = async key => {
    await find(p => p.key === key, async (context, props) => {
        props[0].delete();
        await context.sync();
    });
}

export default {
    find,
    get,
    getKeys,
    set,
    remove
}